import {
  WorkshopModel,
  WorkshopCollectionModel,
  WorkshopFormLookups,
  GridFilter,
  WorkshopFilterModel,
  WorkshopGridLookups,
  WorkshopClientLookups,
  CompanyFormModel,
  ReplaceParticipantModel,
  ImportingResultModel,
  DashboardFilterModel,
  FileDownloadModel,
} from "@/core/models";
import { HttpService } from "@/core/services";

export const WorkshopService = {
  getWorkshop(id: number) {
    return HttpService.getData<WorkshopModel>(`workshops/${id}`);
  },
  deleteWorkshop(id: number) {
    return HttpService.delete(`workshops/${id}`);
  },
  postWorkshop(model: WorkshopModel) {
    return HttpService.postModel("workshops", model);
  },
  putWorkshop(model: WorkshopModel) {
    return HttpService.putModel("workshops", model);
  },
  putWorkshopClient(workshopId: number, model: CompanyFormModel) {
    return HttpService.putModel(`workshops/${workshopId}/client`, model);
  },
  deleteWorkshopClient(workshopId: number, companyId: number) {
    return HttpService.delete(`workshops/${workshopId}/client/${companyId}`);
  },
  postWorkshopClient(workshopId: number, model: CompanyFormModel) {
    return HttpService.postModel(`workshops/${workshopId}/client`, model);
  },
  postWorkshopClientAttendeeReplacement(model: ReplaceParticipantModel) {
    return HttpService.postModel(`workshops/${model.workshopId}/client/${model.companyId}/replace`, model);
  },
  completeWorkshop(id: number) {
    return HttpService.put(`workshops/${id}/complete`);
  },
  updateFacilitator(id: number, facilitatorId?: number) {
    let url = `workshops/${id}/facilitator`;
    if (facilitatorId) {
      url = `${url}?facilitatorId=${facilitatorId}`;
    }
    return HttpService.put(url);
  },
  filterWorkshops(filter: GridFilter & WorkshopFilterModel) {
    return HttpService.filterData<WorkshopCollectionModel, WorkshopFilterModel>("workshops/filter", filter);
  },
  getWorkshopClientLookups() {
    return HttpService.getData<WorkshopClientLookups>("workshops/client/lookups");
  },
  getWorkshopFormLookups() {
    return HttpService.getData<WorkshopFormLookups>("workshops/form/lookups");
  },
  getWorkshopGridLookups() {
    return HttpService.getData<WorkshopGridLookups>("workshops/grid/lookups");
  },
  async importWorkshop(f: any) {
    const file = new FormData();
    file.append("file", f);
    const result = await HttpService.post("/workshops/importing", file, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return result.data as ImportingResultModel;
  },
  downloadSosReport(model: GridFilter & DashboardFilterModel) {
    return HttpService.getData<FileDownloadModel>("workshops/sos/download", { params: model });
  },
  downloadSkillsConsultantReport(model: GridFilter & DashboardFilterModel) {
    return HttpService.getData<FileDownloadModel>("workshops/skills/consultant/download", { params: model });
  },
};
